// src/components/pwa/common/Sidebar.js
// Premium redesigned sidebar with flat navigation items and sleek monochrome styles.

import React from 'react';
import { ChevronLeft, ChevronRight } from 'react-feather';
import logo from '../../../assets/logo.png';

import {
  SidebarContainer,
  LogoArea,
  SidebarLogo,
  MiniLogo,
  CollapseBtn,
  ScrollArea,
  GroupLabel,
  NavItem,
  NavButton,
  IconWrap,
  NavLabel,
  BadgePill
} from './Sidebar.styles';
import { NAV_ITEMS } from './sidebarConfig';

// ─────────────────────────────────────────────
// COMPONENT
// ─────────────────────────────────────────────

const Sidebar = ({ activeTab, onTabPress, onLogout, mode = 'financial', isOpen, toggleSidebar }) => {
  const handleNavClick = (item) => {
    if (item.comingSoon) return;
    onTabPress(item.id);
  };

  // Track groups we've rendered a label for
  const renderedGroups = new Set();

  return (
    <SidebarContainer $open={isOpen}>

      {/* Logo Area */}
      <LogoArea $open={isOpen} onClick={!isOpen ? toggleSidebar : undefined}>
        <MiniLogo $open={isOpen}>N</MiniLogo>
        <SidebarLogo src={logo} alt="NYBANQ" $open={isOpen} />
        <CollapseBtn $open={isOpen} onClick={isOpen ? toggleSidebar : undefined} title={isOpen ? 'Collapse' : 'Expand'}>
          {isOpen ? <ChevronLeft size={13} /> : <ChevronRight size={13} />}
        </CollapseBtn>
      </LogoArea>

      {/* Nav items */}
      <ScrollArea>
        {NAV_ITEMS.map((item) => {
          const Icon = item.Icon;
          const isActive = activeTab === item.id;
          const showGroupLabel = item.group && !renderedGroups.has(item.group);
          if (item.group) renderedGroups.add(item.group);

          return (
            <React.Fragment key={item.id}>
              {showGroupLabel && (
                <GroupLabel $open={isOpen}>{item.group}</GroupLabel>
              )}

              <NavItem $open={isOpen} $active={isActive}>
                <NavButton
                  $open={isOpen}
                  $active={isActive}
                  $disabled={item.comingSoon}
                  onClick={() => handleNavClick(item)}
                  title={!isOpen ? item.label : ''}
                >
                  <IconWrap $active={isActive}>
                    <Icon
                      size={19}
                      color="currentColor"
                    />
                  </IconWrap>
                  <NavLabel $open={isOpen} $active={isActive}>{item.label}</NavLabel>
                  {item.comingSoon && <BadgePill $open={isOpen}>SOON</BadgePill>}
                </NavButton>
              </NavItem>
            </React.Fragment>
          );
        })}
      </ScrollArea>

    </SidebarContainer>
  );
};

export default Sidebar;

